module.exports = __webpack_public_path__ + "img/HK.6738eacd.png";